import React from 'react';
import { css } from '@emotion/core';

import { SPACE_MINIMUM } from '@/styles';
import { FCC } from '@/utils/types';

import ItemHeader from '../item-header';

interface HelpDialogFieldProps {
  fieldName: string;
}

const HelpDialogField: FCC<HelpDialogFieldProps> = ({ fieldName, children }) => (
  <div data-testid="help-dialog-field">
    <ItemHeader>{fieldName}</ItemHeader>
    <div
      css={css`
        margin-top: ${SPACE_MINIMUM}px;
      `}
    >
      {children}
    </div>
  </div>
);

export default HelpDialogField;
